(function () {
    'use strict';

    angular
     .module('questionnaireTemplatesEditModule')
     .controller('ODDQuestionnaireTemplateStaticTextEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$window', 'questionnaireTemplate', 'questionnaireSection', 'oddStaticText', 'oddQuestionnaireTemplateService', 'notificationService', 'businessUnit'];

    function Controller($scope, $state, $window, questionnaireTemplate, questionnaireSection, oddStaticText, oddQuestionnaireTemplateService, notificationService, businessUnit) {

        // scroll to top of the page on init.

        $window.scrollTo(0, 0);
        $scope.questionnaireTemplate = questionnaireTemplate;
        $scope.questionnaireSection = questionnaireSection;
        $scope.ctrlCtxt = {
            questionnaireTemplateStaticText: oddStaticText
        };

        if (!$scope.ctrlCtxt.questionnaireTemplateStaticText.ItemTypeCode) {
            $scope.ctrlCtxt.questionnaireTemplateStaticText.ItemTypeCode = 'ODDStaticText';
        }

        // Go To Questionnaire Template
        $scope.goToQuestionnaireTemplate = function (qTemplate) {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire', { ODDQuestionnaireID: qTemplate.ODDQuestionnaireID }, { reload: true });
        };

        $scope.goToQuestionnaireSection = function () {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire.section', {
                ODDSectionID: questionnaireSection.ODDSectionID
            }, { reload: true });
        };

        // Delete Static Text
        $scope.delete = function (staticText) {
            $scope.ctrlCtxt.isLoading = true;

            oddQuestionnaireTemplateService
             .deleteStaticText(businessUnit.ODDBusinessUnitID,
              questionnaireSection.ODDQuestionnaireID,
              questionnaireSection.ODDSectionID,
              staticText.ODDStaticTextID).then(function () {
                  notificationService.notify('Static Text has been deleted');
                  $state.go('odd.questionnaireTemplatesEdit.questionnaire.section', {
                      ODDSectionID: $scope.questionnaireSection.ODDSectionID
                  }, { reload: true });
              })
             .finally(function () {
                 $scope.ctrlCtxt.isLoading = false;
             });
        };

        // Create Or Update
        $scope.createOrUpdate = function (staticText) {
            $scope.boxModel = staticText;

            if ($scope.boxModel.Content === "") {
                $scope.ctrlCtxt.showSubmitError = true;
                $scope.ctrlCtxt.isFormInvalidMsgShow = true;

                $timeout(function () {
                    $scope.ctrlCtxt.isFormInvalidMsgShow = false;
                }, govNotificationDelay);

                return;
            }

            $scope.ctrlCtxt.isFormInvalidMsgShow = false;
            $scope.ctrlCtxt.showSubmitError = false;
            $scope.ctrlCtxt.isLoading = true;

            // Create StaticText
            if (!staticText.ODDStaticTextID) {

                oddQuestionnaireTemplateService
                 .createStaticText(businessUnit.ODDBusinessUnitID,
                  $scope.questionnaireSection.ODDQuestionnaireID,
                  $scope.questionnaireSection.ODDSectionID,
                  $scope.boxModel)
                 .then(function (createdStaticText) {
                     notificationService.notify('The Static Text was created');
                     $state.go('odd.questionnaireTemplatesEdit.questionnaire.section.staticTextEdit', {
                         ODDStaticTextID: createdStaticText.ODDStaticTextID
                     });
                 }).finally(function () {
                     $scope.ctrlCtxt.isLoading = false;
                 });



            } else {
                oddQuestionnaireTemplateService
                    .updateStaticText(businessUnit.ODDBusinessUnitID,
                        $scope.questionnaireSection.ODDQuestionnaireID,
                        $scope.questionnaireSection.ODDSectionID,
                        $scope.boxModel)
                    .then(function (createdStaticText) {
                        notificationService.notify('The Static Text has been updated');

                        $state.go('odd.questionnaireTemplatesEdit.questionnaire.section.staticTextEdit', {
                            ODDStaticTextID: createdStaticText.ODDStaticTextID
                        }, {
                            reload: true
                        });
                 }).finally(function () {
                     $scope.ctrlCtxt.isLoading = false;
                 });
            }
        };

        var helpBoxContent =
                'You can use commands to apply style to your text. \n\n' +
                'Here are some of the commands:\n' +
                '\n' +
                '| Style | Command| Result |\n' +
                '|---------|---------|--------------|\n' +
                '| italic | \\*text here\\* | *text here* |\n' +
                '| bold| \\*\\*text here\\*\\* | **text here** |\n' +
                '| bold and italic| \\*\\*\\*text here\\*\\*\\* | ***text here*** |\n' +
                '| link | \\[text](http://www.investpsp.ca) | [text](http://www.investpsp.ca) |\n' +
                '\n' +
                'Header 1 text = # before the text\n' +
                'Header 2 text = ## before the text\n' +
                'Header 3 text = ### before the text\n' +
                'Header 4 text = #### before the text\n' +
                'Header 5 text = ##### before the text\n' +
                'Header 6 text = ###### before the text\n' +
                'Exemple for header 4:\n' +
                '#### header 4\n' +
                '\n' +
                'You can create bulleted and numbered lists:\n' +
                '+ Use "**-**" (hyphen) for a bulleted list\n' +
                '  + Prefix "**-**" with 2 spaces to indent the list (4 spaces for a double indentation)\n' +
                '\n' +
                'Numbered\n' +
                '1. Use "**1.**" for a numbered list\n' +
                '  - You can mix them at different levels\n';

        $scope.helpBoxRenderedContent = '<div class="markdown">' + marked(helpBoxContent) + '</div>';
        $scope.moreInfoUrl = 'https://github.com/adam-p/markdown-here/wiki/Markdown-Here-Cheatsheet';
    }
})();